import React from 'react';

const TypingIndicator = ({ text = 'Thinking...' }) => {
  return (
    <div style={{
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px'
    }}>
      {/* Avatar */}
      <div style={{
        width: '36px',
        height: '36px',
        flexShrink: 0,
        background: 'linear-gradient(135deg, rgba(0, 225, 196, 0.2), rgba(95, 255, 230, 0.2))',
        border: '1px solid rgba(0, 225, 196, 0.4)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 0 12px rgba(0, 225, 196, 0.3)',
        fontSize: '18px'
      }}>
        🐂
      </div>

      {/* Typing Bubble */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.08) 100%)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        borderRadius: '16px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        padding: '16px',
        minWidth: '120px'
      }}>
        {/* Header */}
        <div style={{
          fontSize: '0.75rem',
          fontWeight: '700',
          color: '#00e1c4',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          textShadow: '0 0 10px rgba(0, 225, 196, 0.3)',
          marginBottom: '12px'
        }}>
          GIDEON
        </div>

        {/* Animated Dots */}
        <div style={{
          display: 'flex',
          gap: '6px',
          marginBottom: text ? '12px' : '0'
        }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: '8px',
                height: '8px',
                background: '#00e1c4',
                borderRadius: '50%',
                animation: `typing-bounce 1.4s ease-in-out ${i * 0.2}s infinite`,
                boxShadow: '0 0 8px rgba(0, 225, 196, 0.4)'
              }}
            />
          ))}
        </div>

        {/* Status Text */}
        {text && (
          <div style={{
            fontSize: '0.8125rem',
            color: 'rgba(255, 255, 255, 0.6)',
            lineHeight: '1.4'
          }}>
            {text}
          </div>
        )}
      </div>

      {/* Animation Keyframes */}
      <style>{`
        @keyframes typing-bounce {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 1;
          }
          30% {
            transform: translateY(-10px);
            opacity: 0.7;
          }
        }
      `}</style>
    </div>
  );
};

export default TypingIndicator;
